import { getStore } from '../store/store';

/**
 * Function checks if a user is already present in permissions array of view store.
 * @param emailAddress Email address against which we have to do this check.
 */
function isExistingPermissionUser(emailAddress: string): boolean {
    const permissions = getStore().permissions;
    return permissions.some(
        permission => permission.UserId && permission.UserId.PrimarySmtpAddress === emailAddress
    );
}

export default isExistingPermissionUser;
